import { FormEvent, useState } from 'react';
import { replaceTachometer, type TachInfo } from '../../api';
import { useFeedback } from '../../hooks/useFeedback';
import { getApiErrorMessage } from '../../utils/apiError';
import '../modal/ModalBase.css';
import ModalOverlay from '../modal/ModalOverlay';
import ModalPortal from '../modal/ModalPortal';
import './ReplaceTachometerModal.css';

type Props = {
  onClose: () => void;
  onReplaced: (info: TachInfo) => void;
};

const ReplaceTachometerModal = ({ onClose, onReplaced }: Props) => {
  const { showError, feedbackNode } = useFeedback();
  const [newTachStart, setNewTachStart] = useState('0');
  const [replacing, setReplacing] = useState(false);

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    const value = Number(String(newTachStart).replace(',', '.'));
    if (!Number.isFinite(value) || value < 0) {
      showError('Укажите неотрицательное начальное значение');
      return;
    }
    setReplacing(true);
    try {
      const res = await replaceTachometer({ new_tach_start: value });
      onReplaced(res.data);
      onClose();
    } catch (error) {
      showError(getApiErrorMessage(error, 'Не удалось заменить тахометр'));
    }
    setReplacing(false);
  };

  return (
    <ModalPortal onClose={replacing ? undefined : onClose}>
      <ModalOverlay onClose={replacing ? undefined : onClose}>
        {feedbackNode}
        <form
          className="modal replace-tach-modal"
          onClick={(e) => e.stopPropagation()}
          onSubmit={(e) => void handleSubmit(e)}
        >
          <h3>Заменить тахометр</h3>
          <div className="modal-body">
            <label>
              Начало нового тахометра
              <input
                type="text"
                inputMode="decimal"
                autoComplete="off"
                value={newTachStart}
                onChange={(e) => setNewTachStart(e.target.value)}
                disabled={replacing}
              />
            </label>
          </div>
          <div className="modal-actions">
            <button
              type="button"
              className="btn-cancel"
              disabled={replacing}
              onClick={onClose}
            >
              Отмена
            </button>
            <button type="submit" className="btn-save" disabled={replacing}>
              {replacing ? '…' : 'Подтвердить'}
            </button>
          </div>
        </form>
      </ModalOverlay>
    </ModalPortal>
  );
};

export default ReplaceTachometerModal;
